/**
 * Buyback-specific form validators.
 *
 * Validates BUYBACK guardrail fields. All fields are OPTIONAL — an empty field
 * is valid. When a value is provided, it must satisfy its range:
 *   - % of new product price: 0-100
 *   - % of old product quote: 0-100
 *   - absolute value cap (INR): >= 1
 *
 * Mirrors the cashback validator's shape so the same inline-error rendering
 * pattern (FormField errorText + invalid prop) works without changes in the
 * BuybackSection. Extracted from formValidationUtils for single-responsibility.
 *
 * @module buybackValidation
 */

import { UseCampaignFormResult } from 'src/hooks/useCampaignForm/useCampaignForm';
import { parseOptionalNumber } from 'src/utils/helpers';
import { FieldErrors } from '../formValidationUtils';

// ============================================================================
// Public API
// ============================================================================

export function validateBuyback(form: UseCampaignFormResult, f: FieldErrors): void {
    // Each guardrail is optional: skip range checks when the field is left blank.
    // parseOptionalNumber returns undefined for empty input.
    const percentOfAsinPrice = parseOptionalNumber(form.buybackPercentOfAsinPrice);
    if (percentOfAsinPrice != null && (percentOfAsinPrice < 0 || percentOfAsinPrice > 100)) {
        f.buybackPercentOfAsinPrice = { key: 'buyback_percent_of_asin_price_range' };
    }

    const percentOfBuybackOffer = parseOptionalNumber(form.buybackPercentOfBuybackOffer);
    if (percentOfBuybackOffer != null && (percentOfBuybackOffer < 0 || percentOfBuybackOffer > 100)) {
        f.buybackPercentOfBuybackOffer = { key: 'buyback_percent_of_buyback_offer_range' };
    }

    const absoluteValueCap = parseOptionalNumber(form.buybackAbsoluteValueCap);
    if (absoluteValueCap != null && absoluteValueCap < 1) {
        f.buybackAbsoluteValueCap = { key: 'buyback_absolute_value_cap_range' };
    }
}
